<template>
    <BaseDialog
        :value="dialog"
        :title="$t('message.assignSpotDialog.title')"
        headerClass="tw-text-white tw-bg-primary elevation-4 tw-mb-4"
        :showCloseButton="true"
        :onClose="closeDialog"
        @input="closeDialog"
        :width="600"
    >
        <div class="tw-mb-4 tw-text-gray-500 tw-font-bold">
            {{ $t('message.selectAccountText') }}
        </div>
        <v-list class="tw-p-0" v-if="filteredAccounts.length > 0">
            <v-list-item
                v-for="account in filteredAccounts"
                :key="account.id"
                class="tw-px-0"
            >
                <v-list-item-avatar class="tw-ml-2">
                    <Avatar :size="36" :fullname="account.fullName" />
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>{{
                        account.fullName
                    }}</v-list-item-title>
                    <v-list-item-subtitle class="tw-capitalize">{{
                        account.relationship
                    }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn
                        :loading="loadingButton === account.id"
                        :disabled="
                            loadingEmail ||
                            (loadingButton !== null &&
                                loadingButton !== account.id)
                        "
                        class="bg-dark-custom text-uppercase"
                        @click="assignSpot(account)"
                        >{{ $t('message.assign') }}</v-btn
                    >
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <div v-else>
            <span class="tw-text-gray-500 tw-text-sm">{{
                $t('message.noAccounts')
            }}</span>
        </div>

        <div class="tw-flex tw-items-center tw-my-4">
            <v-divider class="tw-flex-1" />
            <span class="tw-mx-4 tw-text-gray-500 tw-font-medium">OR</span>
            <v-divider class="tw-flex-1" />
        </div>

        <div class="tw-mb-2 tw-text-gray-500 tw-font-bold">
            {{ $t('message.assignViaEmail') }}
        </div>
        <div class="tw-flex tw-items-center tw-mb-4">
            <v-text-field
                class="tw-flex-1"
                prepend-inner-icon="mdi-email-outline"
                placeholder="vibefam@gmail.com"
                outlined
                dense
                hide-details
                v-model="inputEmail"
            />
            <v-btn
                class="tw-ml-4"
                color="grey lighten-2 text-uppercase"
                :disabled="!inputEmail || loadingButton !== null"
                :loading="loadingEmail"
                @click="assignSpotViaEmail"
            >
                {{ $t('message.assign') }}
            </v-btn>
        </div>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/dialog/BaseDialog.vue'
import Avatar from 'vue-avatar-component'
import { mapGetters } from 'vuex'
import {
    assignClassSpotForFamily,
    assignClassSpotForEmail,
} from '@/modules/subAccounts/api/subAccountsApi'
import { useToast } from '@/components/base/toast/composable/useToast'
import { AUTHENTICATION_MODULE_NAME } from '@/store/moduleNames'
export default {
    components: { BaseDialog, Avatar },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        accounts: {
            type: Array,
            required: true,
        },
        selectedSpot: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            inputEmail: '',
            selectedAccount: {},
            loadingButton: null,
            loadingEmail: false,
        }
    },
    watch: {
        isOpen(newVal) {
            this.dialog = newVal
        },
    },
    computed: {
        ...mapGetters({
            user: `${AUTHENTICATION_MODULE_NAME}/getUser`,
        }),
        filteredAccounts() {
            return this.accounts.filter(
                (account) => account.id !== this.selectedSpot.userId
            )
        },
    },
    setup() {
        const { showSuccessToast, showErrorToast } = useToast()
        return { showSuccessToast, showErrorToast }
    },
    methods: {
        closeDialog() {
            this.dialog = false
            this.$emit('close')
        },
        async assignSpot(account) {
            if (!this.selectedSpot.classId || !this.selectedSpot.id) return

            this.loadingButton = account.id
            const result = await assignClassSpotForFamily(
                this.selectedSpot.classId,
                this.selectedSpot.id,
                account.id
            )
            if (result.success) {
                this.closeDialog()
                this.$emit('refresh')
            } else {
                this.showErrorToast(result.error)
            }
            this.loadingButton = null
        },
        async assignSpotViaEmail() {
            if (!this.inputEmail) return
            this.loadingEmail = true
            const result = await assignClassSpotForEmail(
                this.selectedSpot.classId,
                this.selectedSpot.id,
                this.inputEmail
            )
            if (result.success) {
                this.closeDialog()
                this.$emit('refresh')
            } else {
                this.showErrorToast(result.error)
            }
            this.loadingEmail = false
        },
    },
}
</script>

<style>
.bg-dark-custom {
    background-color: #18181b !important;
    color: #fff !important;
}
</style>
